// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"346":"ee3e1333","633":"cfc2e862","816":"547ac5ae"}[chunkId] + ".chunk.js";
};